<template>
  <former-button
    v-if="!processing"
    ref="button"
    :key="key"
    class="former-submit"
    focusless
    :color="color"
    :disabled="processing"
    :icon="icon"
    :iconed="iconed"
    @click="submit"
  >
    <slot v-if="label">
      {{ label }}
    </slot>
  </former-button>

  <spinner-animated
    v-else
    class="former-submit-spinner"
    color="gray"
  />
</template>

<script>
  import FormerButton from '@/components/Former/Button.vue';
  import SpinnerAnimated from '@/components/Spinner/Animated.vue';

  export default {
    name: 'FormerSubmit',
    components: {
      FormerButton,
      SpinnerAnimated,
    },
    props: {
      processing: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '',
      },
    },
    computed: {
      iconed() {
        return !!this.icon && !this.label;
      },
      key() {
        return `${this.icon}-${this.label}`;
      },
    },
    methods: {
      submit() {
        this.$emit('submit');
      },
      focus() {
        const {
          button,
        } = this.$refs;

        if (button) {
          button.focus();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-submit {
    position: relative;
  }

  .former-submit-spinner {
    margin: 0 $gutter-small;
  }
</style>
